// extracted by mini-css-extract-plugin
export var arrow = "_c4-2";
export var label = "_c4-1";
export var reminder = "_c4-0";